
/* eslint-disable @typescript-eslint/no-shadow */
export namespace BoUserRole {
  export enum BoUserRole {
    ADMIN = "ADMIN",
    RESEARCHER = "RESEARCHER",
  }

  export interface BoUserRoleDTO {
    case: string;
  }

  export const fromDTO = (dto: BoUserRoleDTO): BoUserRole => {
    if (dto === undefined || dto === null) {
      throw new InvalidBoUserRoleError(
        `Invalid DTO ${dto} provided for BoUserRole.BoUserRole`
      );
    }
    switch (dto.case) {
      case "ADMIN":
        return BoUserRole.ADMIN;
      case "RESEARCHER":
        return BoUserRole.RESEARCHER;
      default:
        throw new InvalidBoUserRoleError(
          `Case ${dto.case} is not valid case of BoUserRole.BoUserRole`
        );
    }
  };

  export const toDTO = (boUserRole: BoUserRole): BoUserRoleDTO => {
    const enumDTO = {
      case: BoUserRole[boUserRole],
    };
    return enumDTO;
  };
}

export class InvalidBoUserRoleError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBoUserRoleError";
  }
}
export class InvalidBoUserRoleAdminError extends InvalidBoUserRoleError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBoUserRoleAdminError";
  }
}

export class InvalidBoUserRoleResearcherError extends InvalidBoUserRoleError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBoUserRoleResearcherError";
  }
}
